module.exports = __webpack_public_path__ + "static/media/rm3.f4365290.jpg";